/**
 * @ngdoc directive
 * @name formswitchmulti
 *
 * @description
 * Radio button layout component
 */
module.directive('formSwitchMulti', function ($timeout) {
    'use strict';
    return {
        restrict: 'E',
        require: '^ngModel',
        replace: true,
        transclude: true,
        scope: {
            model: '=ngModel',
            name: '@',
            suffix: '@?',
            readonly: '=?',
            labels: '='
        },
        link: function ($scope, element, attrs, ctrl) {
            $scope.isRequired = !!attrs.isRequired;
        },
        template:
                '<p class="aqua-form--switches">' +
                '  <span class="aqua-form--label" ng-transclude></span>' +
                '  <span class="aqua-form--switches--inputs">' +
                '    <label class="aqua-form--switches--label" ' +
                '      ng-repeat="label in labels" ' +
                '      ng-class="{\'is-active\': model.acquis === label.value, \'is-readonly\': (readonly), \'is-disabled\': (label.disabled), \'ng-invalid\': hasError()}">' +
                '      <span class="aqua-form--switches--input">' +
                '        <input type="radio" name="{{name + suffix }}" class="aqua-form--switches--input--box" ng-model="model.acquis" ng-value="label.value" ng-required="isRequired" ng-disabled="(readonly || label.disabled)">' +
                '      </span>' +
                '      <span class="aqua-form--switches--input--label is-sr-only">{{label.text}}</span>' +
                '    </label>' +
                '  </span>' +
                '</p>'
    };
});
